import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { RoleType, UserGroupType } from 'tnx-admin-service/authorization/constants';
import { RoleService } from 'tnx-admin-service/authorization/role/services';
import { UserGroupService } from 'tnx-admin-service/authorization/usergroup/services';
import {
    AutoCompletePickerControlSchema,
    CoCauToChucService,
    ComponentContextService,
    DataFormBase,
    DropdownControlSchema,
    EntityPickerColumn,
    EventData,
    Filter,
    FormSchemaBase,
    Operator,
    TextAreaControlSchema,
    TextControlSchema,
    UserPickerControlSchema,
    UserV5Service,
} from 'tnx-shared';


@Component({
    selector: 'usergroup-form',
    templateUrl: './usergroup-form.component.html',
    styleUrls: ['./usergroup-form.component.scss'],
    providers: [ComponentContextService],
})
export class UserGroupFormComponent extends DataFormBase implements OnInit {

    @ViewChild('organization', { static: true }) organizationRef: TemplateRef<any>;
    @ViewChild('organizationFilter', { static: true }) organizationFilterRef: TemplateRef<any>;

    searchSchema: any = {};

    constructor(
        protected _injector: Injector,
        private _userGroupService: UserGroupService,
        private _roleService: RoleService,
        public _userV5Service: UserV5Service,
        public _organizationService: CoCauToChucService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._userGroupService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'code',
                label: 'Mã'
            }),
            new TextControlSchema({
                field: 'name',
                label: 'Tên'
            }),
            new AutoCompletePickerControlSchema({
                mdWidth: 12,
                field: 'idRoles',
                title: 'Chọn vai trò',
                label: 'Vai trò',
                displayField: 'name',
                baseService: this._roleService,
                defaultFilters: () => {
                    const filters = <Filter[]>[];
                    filters.push({ field: 'type', operator: Operator.equal, value: RoleType.Group.toString() });
                    return filters;
                },
                columns: [
                    new EntityPickerColumn({
                        code: 'code',
                        label: 'Mã vai trò',
                        operator: Operator.contain,
                    }),
                    new EntityPickerColumn({
                        code: 'name',
                        label: 'Tên vai trò',
                        operator: Operator.contain,
                    })
                ]
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: 'Mô tả',
                mdWidth: 12
            }),
            new UserPickerControlSchema({
                field: 'idUsers',
                label: 'Chọn người dùng',
                placeholder: 'Chọn người dùng',
                multiple: true,
                mdWidth: 12
            })
        ];

        this.initSearchSchema();
    }

    initSearchSchema() {
        this.searchSchema.idOrgranization = new DropdownControlSchema({
            field: 'idOrgranization',
            placeholder: 'Chọn đơn vị',
            baseService: this._organizationService,
            sortField: 'idDuongDan',
            fieldPlus: 'idDuongDan',
            isTree: true,
            fieldTree: 'idCha',
            valueParentRoot: this._commonService.guidEmpty(),
            // isServerLoad: true, Option này đang không chạy được trong case này
            loadOnInit: true,
            multiple: false
        });
    }

    async getDetailCustom() {
        return this._userGroupService.getDetailCustom(this.model.data.id, this._commonService.guidEmpty());
    }

    async onFormInitialized(formEvent: EventData) {
        if (!this.model.data.id) {
            formEvent.model.type = UserGroupType.Group;
        }
    }

    async modifyDetailData(data) {
        // chuyển về xử lý bên API
        // data.idUsers = data.userGroupHasUsers.map(x => x.idUser);
        // data.idRoles = data.userGroupHasRoles.map(x => x.idRole);
    }

    onBeforeSave() {
        // trước khi lưu
    }
}

